export const STAGE_AUTO_NAVIGATION = "STAGE_AUTO_NAVIGATION"
export const NAVIGATE_PAGE = "NAVIGATE_PAGE"



// WEBPACK FOOTER //
// ./modules/auto-nav-url-aon/actions/actionTypes.ts